// extracted by mini-css-extract-plugin
export default {"input":"_10TN3IOIGaNAfloUffTWaH"};